import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSidebarOnStyle0 = cosmosIconCss;

const CosmosIconSidebarOn$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSidebarOn extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fb6ad3aa632cca1b575b87cc420f9054c01f73b2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b8916866243c18f8b942fd1186117505333a31a6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c0679800bede206ba71fd6dbe5426cbd0b31c2ad', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.54 4.002 19.36 4c.223 0 .304.023.385.067a.454.454 0 0 1 .19.189c.043.081.066.162.066.385v12.718c0 .223-.023.304-.067.385a.454.454 0 0 1-.189.19c-.081.043-.162.066-.385.066H2.641c-.223 0-.304-.023-.385-.067a.454.454 0 0 1-.19-.189.59.59 0 0 1-.064-.285L2 4.641c0-.223.023-.304.067-.385a.454.454 0 0 1 .189-.19.59.59 0 0 1 .285-.064ZM18.5 5.5h-15v11h15v-11ZM17 7h-4v8h4V7Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSidebarOnStyle0; }
}, [1, "cosmos-icon-sidebar-on", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sidebar-on"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sidebar-on":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSidebarOn$1);
            }
            break;
    } });
}

const CosmosIconSidebarOn = CosmosIconSidebarOn$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSidebarOn, defineCustomElement };
